import { Customer, api } from "./customers";

export interface DashboardCustomersResponse {
  status: string;
  message: string;
  total_count: number;
  total_pages: number;
  current_page: number;
  data: Customer[];
  per_page: number;
  prev_page: number;
  nextPage: number;
}
export interface AppinmentById {
  status: string;
  message: string;
  data: Customer[];
}
type DasboardCustomersResponse = DashboardCustomersResponse[];
type AppoinmentByidResponse = AppinmentById[];

export const PotentialLeadsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getPotentialLeadsList: build.query<DasboardCustomersResponse, any>({
      query: (pagi) =>
        `new_customer?page=${pagi?.pageNo}&filter=${pagi?.name}`,
      providesTags: (result) =>
        result
          ? [
              ...result?.["data"]?.map(({ id }) => ({
                type: "PotentialLeads" as const,
                id,
              })),
              { type: "PotentialLeads", id: "LIST" },
            ]
          : [{ type: "PotentialLeads", id: "LIST" }],
    }),
   
    deletePotentialLead: build.mutation<{ success: boolean; id: number }, number>({
        query(id) {
            return {
                url: `new_customer/${id}`,
                method: 'DELETE',
            }
        },
        invalidatesTags: [{ type: 'PotentialLeads', id: 'LIST' }],
    }),
  }),
});
export const { useGetPotentialLeadsListQuery,useDeletePotentialLeadMutation } =
  PotentialLeadsApi;
